import { B2C_LISTING_FEATURE_KEYS, B2C_LISTINGS_SORT_VALUES, } from '@/api/network/listings/requests/GetListingsRequest';
/** Верхняя граница для слайдеров и полей цены в фильтрах (EUR) */
export const LISTINGS_PRICE_FILTER_MAX = 5000000;
const B2C_LISTING_FEATURE_KEYS_SET = new Set(B2C_LISTING_FEATURE_KEYS);
const LISTINGS_FEATURE_LABELS = {
    ELEVATOR: { en: 'Elevator', de: 'Aufzug', it: 'Ascensore' },
    AIR_CONDITIONING: { en: 'Air conditioning', de: 'Klimaanlage', it: 'Aria condizionata' },
    FIREPLACE: { en: 'Fireplace', de: 'Kamin', it: 'Caminetto' },
    SWIMMING_POOL: { en: 'Swimming pool', de: 'Pool', it: 'Piscina' },
    ALARM_SYSTEM: { en: 'Alarm system', de: 'Alarmanlage', it: 'Sistema di allarme' },
    INTERNET: { en: 'Internet', de: 'Internet', it: 'Internet' },
    BALCONY: { en: 'Balcony', de: 'Balkon', it: 'Balcone' },
    TERRACE: { en: 'Terrace', de: 'Terrasse', it: 'Terrazza' },
    GARDEN: { en: 'Garden', de: 'Garten', it: 'Giardino' },
    PARKING: { en: 'Parking', de: 'Parkplatz', it: 'Parcheggio' },
    CELLAR: { en: 'Cellar', de: 'Keller', it: 'Cantina' },
};
export const LISTINGS_FEATURE_FILTERS = B2C_LISTING_FEATURE_KEYS.map((value) => ({
    value,
    label: LISTINGS_FEATURE_LABELS[value],
}));
const LISTINGS_SORT_LABELS = {
    newest: { en: 'Newest', de: 'Neueste', it: 'Più recenti' },
    price_asc: { en: 'Price: low to high', de: 'Preis: aufsteigend', it: 'Prezzo: crescente' },
    price_desc: { en: 'Price: high to low', de: 'Preis: absteigend', it: 'Prezzo: decrescente' },
    area_asc: { en: 'Area: small to large', de: 'Fläche: aufsteigend', it: 'Superficie: crescente' },
    area_desc: { en: 'Area: large to small', de: 'Fläche: absteigend', it: 'Superficie: decrescente' },
};
export const LISTINGS_SORT_FILTERS = B2C_LISTINGS_SORT_VALUES.map((value) => ({
    value,
    label: LISTINGS_SORT_LABELS[value],
}));
export function getListingFeatureRequestValues(selectedFeatures) {
    if (!Array.isArray(selectedFeatures) || selectedFeatures.length === 0) {
        return [];
    }
    const uniq = new Set();
    for (const feature of selectedFeatures) {
        const normalized = typeof feature === 'string' ? feature.trim() : '';
        if (!normalized || !B2C_LISTING_FEATURE_KEYS_SET.has(normalized)) {
            continue;
        }
        uniq.add(normalized);
    }
    return Array.from(uniq);
}
export function toggleListingFeature(selectedFeatures, feature) {
    if (selectedFeatures.includes(feature)) {
        return selectedFeatures.filter((value) => value !== feature);
    }
    return [...selectedFeatures, feature];
}
export const LISTINGS_PROPERTY_TYPE_FILTERS = {
    residential: {
        groupId: 'RESIDENTIAL',
        value: 'RESIDENTIAL',
        label: { en: 'Residential', de: 'Wohnen', it: 'Residenziale' },
        house: {
            subgroupId: 'HOUSE',
            value: 'RESIDENTIAL_HOUSE',
            label: { en: 'House', de: 'Haus', it: 'Casa' },
            items: [
                { value: 'DETACHED_HOUSE', label: { en: 'Detached house', de: 'Einfamilienhaus', it: 'Casa indipendente' } },
                { value: 'SEMI_DETACHED_HOUSE', label: { en: 'Semi-detached house', de: 'Doppelhaushälfte', it: 'Casa bifamiliare' } },
                { value: 'DUPLEX', label: { en: 'Duplex', de: 'Duplex', it: 'Duplex' } },
                { value: 'COUNTRY_HOUSE', label: { en: 'Country house', de: 'Landhaus/Finca', it: 'Casa di campagna' } },
                { value: 'APARTMENT_HOUSE', label: { en: 'Apartment house', de: 'Mehrfamilienhaus', it: 'Edificio' } },
                { value: 'TERRACED_HOUSE', label: { en: 'Terraced house', de: 'Reihenhaus', it: 'Villetta a schiera' } },
                { value: 'CASTLE', label: { en: 'Castle', de: 'Schloss', it: 'Castello' } },
                { value: 'VILLA', label: { en: 'Villa', de: 'Villa', it: 'Villa' } },
                { value: 'TOWNHOUSE', label: { en: 'Townhouse', de: 'Stadthaus', it: 'Cielo-terra' } },
                { value: 'BUNGALOW', label: { en: 'Bungalow', de: 'Bungalow', it: 'Bungalow' } },
                { value: 'SPECIAL_PROPERTY', label: { en: 'Special property', de: 'Besondere Immobilie', it: 'Proprietà speciale' } },
                { value: 'OTHER_HOUSE', label: { en: 'Other', de: 'Sonstiges', it: 'Altri' } },
            ],
        },
        apartment: {
            subgroupId: 'APARTMENT',
            value: 'RESIDENTIAL_APARTMENT',
            label: { en: 'Apartment', de: 'Wohnung', it: 'Appartamento' },
            items: [
                { value: 'APARTMENT', label: { en: 'Flat', de: 'Wohnung', it: 'Appartamento' } },
                { value: 'MAISONETTE', label: { en: 'Maisonette', de: 'Maisonette Wohnung', it: 'Maisonette' } },
                { value: 'LOFT', label: { en: 'Loft', de: 'Loft', it: 'Loft' } },
                { value: 'PENTHOUSE', label: { en: 'Penthouse', de: 'Penthouse Wohnung', it: 'Attico' } },
                { value: 'ATTIC_APARTMENT', label: { en: 'Attic apartment', de: 'Dachgeschoss', it: 'Appartamento mansardato' } },
                { value: 'OTHER_APARTMENT', label: { en: 'Other', de: 'Sonstiges', it: 'Altri' } },
            ],
        },
        land: {
            subgroupId: 'LAND',
            value: 'RESIDENTIAL_LAND',
            label: { en: 'Land', de: 'Grundstück', it: 'Terreno' },
            items: [
                { value: 'RESIDENTIAL_SITE', label: { en: 'Site', de: 'Grundstück', it: 'Lotto edificabile' } },
                { value: 'RESIDENTIAL_PARKING', label: { en: 'Parking', de: 'Parkfläche', it: 'Parcheggio' } },
                { value: 'RESIDENTIAL_STORAGE', label: { en: 'Storage', de: 'Lagerung', it: 'Deposito' } },
                { value: 'RESIDENTIAL_LAND_PLOT', label: { en: 'Land', de: 'Land', it: 'Terreno' } },
                { value: 'RESIDENTIAL_OTHER_LAND', label: { en: 'Other', de: 'Sonstiges', it: 'Altri' } },
            ],
        },
    },
    commercial: {
        groupId: 'COMMERCIAL',
        value: 'COMMERCIAL',
        label: { en: 'Commercial', de: 'Gewerbe', it: 'Commerciale' },
        items: [
            { value: 'INVESTMENT', label: { en: 'Investment', de: 'Investition', it: 'Investimento' } },
            { value: 'OFFICE', label: { en: 'Office', de: 'Büro', it: 'Ufficio' } },
            { value: 'STORE', label: { en: 'Store', de: 'Geschäft', it: 'Negozio' } },
            { value: 'HOTEL', label: { en: 'Hotel', de: 'Hotel', it: 'Hotel' } },
            { value: 'GASTRONOMY', label: { en: 'Gastronomy', de: 'Gastronomie', it: 'Gastronomia' } },
            { value: 'INDUSTRY', label: { en: 'Industry and logistics', de: 'Industrie und Logistik', it: 'Industria e logistica' } },
            { value: 'AGRICULTURE', label: { en: 'Agriculture and forestry', de: 'Land- und Forstwirtschaft', it: 'Agricoltura e silvicoltura' } },
            { value: 'COMMERCIAL_PARKING', label: { en: 'Parking', de: 'Parkfläche', it: 'Parcheggio' } },
            { value: 'COMMERCIAL_LAND', label: { en: 'Land', de: 'Land', it: 'Terreno' } },
            { value: 'COMMERCIAL_SPACE', label: { en: 'Commercial space', de: 'Gewerbefläche', it: 'Spazio commerciale' } },
            { value: 'OTHER_COMMERCIAL', label: { en: 'Other', de: 'Sonstiges', it: 'Altro' } },
        ],
    },
    development: {
        groupId: 'DEVELOPMENT',
        value: 'DEVELOPMENT',
        label: { en: 'Development', de: 'Neubauprojekt', it: 'Nuove costruzioni' },
    },
};
export const LISTINGS_PROPERTY_TOP_LEVEL_KEYS = [
    'residential',
    'commercial',
    'development',
];
export const LISTINGS_PROPERTY_RESIDENTIAL_GROUP_KEYS = [
    'house',
    'apartment',
    'land',
];
export const LISTINGS_PROPERTY_TOP_LEVEL_FILTERS = LISTINGS_PROPERTY_TOP_LEVEL_KEYS.map((key) => ({
    key,
    groupId: LISTINGS_PROPERTY_TYPE_FILTERS[key].groupId,
    value: LISTINGS_PROPERTY_TYPE_FILTERS[key].value,
    label: LISTINGS_PROPERTY_TYPE_FILTERS[key].label,
}));
export const LISTINGS_PROPERTY_RESIDENTIAL_FILTER_GROUPS = LISTINGS_PROPERTY_RESIDENTIAL_GROUP_KEYS.map((key) => ({
    key,
    subgroupId: LISTINGS_PROPERTY_TYPE_FILTERS.residential[key].subgroupId,
    value: LISTINGS_PROPERTY_TYPE_FILTERS.residential[key].value,
    label: LISTINGS_PROPERTY_TYPE_FILTERS.residential[key].label,
    items: LISTINGS_PROPERTY_TYPE_FILTERS.residential[key].items,
}));
const PROPERTY_TYPE_LABELS = (() => {
    const map = new Map();
    const addLabel = (value, label) => {
        if (!map.has(value)) {
            map.set(value, label);
        }
    };
    for (const option of LISTINGS_PROPERTY_TOP_LEVEL_FILTERS) {
        addLabel(option.value, option.label);
    }
    for (const group of LISTINGS_PROPERTY_RESIDENTIAL_FILTER_GROUPS) {
        addLabel(group.value, group.label);
        for (const item of group.items) {
            addLabel(item.value, item.label);
        }
    }
    for (const item of LISTINGS_PROPERTY_TYPE_FILTERS.commercial.items) {
        addLabel(item.value, item.label);
    }
    addLabel('ROOM', { en: 'Room', de: 'Zimmer', it: 'Stanza' });
    addLabel('CELLAR', { en: 'Storage', de: 'Keller', it: 'Cantina' });
    addLabel('GARAGE', { en: 'Garage', de: 'Garage', it: 'Garage' });
    return map;
})();
const LEGACY_GROUP_MAP = {
    HOUSE: 'residential',
    LAND: 'residential',
    SITE: 'residential',
    STORAGE: 'residential',
    OTHER_LAND: 'residential',
};
function getTopLevelForValue(value) {
    if (value === LISTINGS_PROPERTY_TYPE_FILTERS.development.value) {
        return 'development';
    }
    if (value === LISTINGS_PROPERTY_TYPE_FILTERS.commercial.value
        || LISTINGS_PROPERTY_TYPE_FILTERS.commercial.items.some((item) => item.value === value)) {
        return 'commercial';
    }
    if (value === LISTINGS_PROPERTY_TYPE_FILTERS.residential.value
        || LISTINGS_PROPERTY_RESIDENTIAL_FILTER_GROUPS.some((group) => group.value === value || group.items.some((item) => item.value === value))) {
        return 'residential';
    }
    return LEGACY_GROUP_MAP[value];
}
function keepOnlySingleGroup(selectedTypes) {
    if (selectedTypes.length <= 1) {
        return selectedTypes;
    }
    const lastSelected = selectedTypes[selectedTypes.length - 1];
    const activeGroup = getTopLevelForValue(lastSelected);
    if (!activeGroup) {
        return selectedTypes;
    }
    return selectedTypes.filter((type) => getTopLevelForValue(type) === activeGroup);
}
function getGroupScopedSelection(selectedTypes, value) {
    const targetGroup = getTopLevelForValue(value);
    if (!targetGroup) {
        return selectedTypes;
    }
    return selectedTypes.filter((type) => getTopLevelForValue(type) === targetGroup);
}
export function getListingPropertyTypeLabel(value) {
    return PROPERTY_TYPE_LABELS.get(value);
}
export function getListingPropertyTopLevelKey(value) {
    if (!value) {
        return undefined;
    }
    return getTopLevelForValue(value);
}
export function getListingPropertyTypeRequestValues(selectedTypes) {
    if (selectedTypes.length === 0) {
        return [];
    }
    const singleGroupSelection = keepOnlySingleGroup(selectedTypes);
    return Array.from(new Set(singleGroupSelection));
}
export function getListingPropertyTypeRequestValue(selectedTypes) {
    const values = getListingPropertyTypeRequestValues(selectedTypes);
    if (values.length === 0) {
        return undefined;
    }
    return values[values.length - 1];
}
export function toggleListingPropertyType(selectedTypes, value) {
    const scoped = getGroupScopedSelection(selectedTypes, value);
    if (scoped.includes(value)) {
        return scoped.filter((type) => type !== value);
    }
    return [...scoped, value];
}
export function setListingPropertyGroupSelection(selectedTypes, groupValue, itemValues, checked) {
    const scoped = getGroupScopedSelection(selectedTypes, groupValue);
    if (!checked) {
        return scoped.filter((type) => type !== groupValue && !itemValues.includes(type));
    }
    const next = [...scoped.filter((type) => type !== groupValue)];
    for (const itemValue of itemValues) {
        if (!next.includes(itemValue)) {
            next.push(itemValue);
        }
    }
    return [...next.filter((type) => type !== groupValue), groupValue];
}
export function toggleListingPropertyChild(selectedTypes, childValue, groupValue) {
    const scoped = getGroupScopedSelection(selectedTypes, groupValue ?? childValue);
    if (scoped.includes(childValue)) {
        return scoped.filter((type) => type !== childValue && type !== groupValue);
    }
    return [...scoped.filter((type) => type !== groupValue), childValue];
}
export function isListingPropertyGroupChecked(selectedTypes, groupValue, itemValues) {
    const scoped = getGroupScopedSelection(selectedTypes, groupValue);
    if (scoped.includes(groupValue)) {
        return true;
    }
    if (itemValues.length === 0) {
        return false;
    }
    return itemValues.every((value) => scoped.includes(value));
}
